import React, { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { getAllRooms } from "../modules/rooms/store";
import { useRoomSignals } from "../graphql/roomSignals";

export const RoomSignalsContext = React.createContext({
    roomSignals: null,
    dataVersion: null,
    loading: null,
    error: null,
    hasSignal: () => null,
    signalsFor: () => null,
});

export const RoomSignalsProvider = ({ children, pollInterval = 60000 }) => {
    const rooms = useSelector(getAllRooms);

    const {
        query: loadRoomSignals,
        called,
        loading,
        error,
        data: roomSignals,
        dataVersion,
    } = useRoomSignals({ rooms, pollInterval });

    useEffect(() => {
        if (!called && rooms && Object.keys(rooms).length > 0) {
            loadRoomSignals();
        }
    }, [rooms]);

    useEffect(() => {
        if (error) {
            console.error(error);
        }
    }, [error]);

    const contextValue = useMemo(
        () => ({
            roomSignals,
            dataVersion,
            loading,
            error,
            hasSignal: (projectRef, roomNumber) => {
                return roomSignals?.some(
                    (action) =>
                        action &&
                        (!projectRef || action.projectRef === projectRef) &&
                        (!roomNumber || Number(action.roomNumber) === Number(roomNumber)),
                );
            },
            signalsFor: (projectRef, roomNumber) => {
                return roomSignals?.filter(
                    (action) =>
                        (!projectRef || action.projectRef === projectRef) &&
                        (!roomNumber || Number(action.roomNumber) === Number(roomNumber)),
                );
            },
        }),
        [roomSignals, dataVersion, loading, error],
    );

    return <RoomSignalsContext.Provider value={contextValue}>{children}</RoomSignalsContext.Provider>;
};
